/** @jsx jsx */
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { useTheme, Typography } from '@material-ui/core';

import iconError from 'assets/icons/iconError.svg';
import { ICustomTheme } from 'interfaces';

const WarningContainer = styled.div(({ theme }: { theme: ICustomTheme }) => ({
  textAlign: 'center',
  padding: theme.spacing(6),
}));

export default function WarningTextNoDeclarations(): JSX.Element {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();

  return (
    <WarningContainer>
      <img src={iconError} alt="error-icon" />
      <Typography
        css={{
          fontWeight: theme.typography.fontWeightBold,
          fontSize: 28,
          marginTop: theme.spacing(3),
        }}
        variant="h4"
        dangerouslySetInnerHTML={{
          __html: t(
            'challenges.declaration.history.warning_text_no_declarations',
          ),
        }}
      />
    </WarningContainer>
  );
}
